import { post } from '@/utils/http'
// 苹果树页面数据
export const getTree = function (data) {
    return post({
        url: "/app/apple/getAppleTree",
        data
    })
}
// 历史苹果树
export const getHistoryAppleTree = function (data) {
    return post({
        url: "/app/apple/getHistoryAppleTree",
        data
    })
}
// 其他人是否可查看我的果园
export const getShowAppleTree = function (data) {
    return post({
        url: "/app/apple/getShowAppleTree",
        data
    })
}
// 修改其他人是否可查看我的果园
export const updateShowAppleTree = function (data) {
    return post({
        url: "/app/apple/updateShowAppleTree",
        data
    })
}
